export enum ApplicationState {
  PROSPECT = 'prospect',
  QUALIFYING = 'qualifying',
  UNQUALIFIED = 'unqualified',
  UPLOADING = 'uploading',
  REVIEWING = 'reviewing',
  COMPLETED = 'completed',
  ACCEPTED = 'accepted',
  REFUSED = 'refused',
  ABANDONED = 'abandoned',
}

export enum FrontApplicationState {
  SUCCESS = 'success',
  FAILED = 'failed',
  WAITING_LIST = 'waiting_list',
}

export type State = ApplicationState | FrontApplicationState

export interface StatusTranslate {
  green?: boolean
  red?: boolean
  orange?: boolean
  blue?: boolean
  grey?: boolean
  text: string
}
export const ApplicationStateTranslate: { [key in ApplicationState]: StatusTranslate } = {
  [ApplicationState.PROSPECT]: { text: 'Prospect', orange: true },
  [ApplicationState.QUALIFYING]: { text: 'Formulaire en cours', orange: true },
  [ApplicationState.UNQUALIFIED]: { text: 'Recalée', orange: true },
  [ApplicationState.UPLOADING]: { text: 'Dossier en cours', orange: true },
  [ApplicationState.REVIEWING]: { text: 'Dossier en analyse', orange: true },
  [ApplicationState.COMPLETED]: { text: 'Dossier validé', orange: true },
  [ApplicationState.ACCEPTED]: { text: 'Retenue', green: true },
  [ApplicationState.REFUSED]: { text: 'Refusée', red: true },
  [ApplicationState.ABANDONED]: { text: 'Abandonnée', red: true },
}
